module.exports = __webpack_public_path__ + "static/media/1_8.ca73622b.png";